module.exports = __webpack_public_path__ + "static/media/map.44241601.png";